import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import React from "react";
import "./EngagementConfirmationModal.scss";
import Button from "../Button/Button";

type Props = {
  isVisible: boolean;
  cancelBtnRejectHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  confirmBtnApproveHandler: (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => void;
  heading?: string;
  message?: string | React.ReactNode;
  loading?: boolean;
  CancelBtnLabel?: string;
  ConfirmBtnLabel?: string;
  isLoading?: boolean;
};

export default function EngagementConfirmationModal({
  isVisible,
  cancelBtnRejectHandler,
  confirmBtnApproveHandler,
  heading,
  message,
  CancelBtnLabel = "Cancel",
  ConfirmBtnLabel = "Save",
  isLoading = false,
}: Props) {
  return (
    <>
      <MotifModal
        onClose={() =>
          cancelBtnRejectHandler({} as React.MouseEvent<HTMLButtonElement>)
        }
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
        className="engagementConfirmationModal"
      >
        <div className="confirmationModalWrapper">
          <MotifModalHeader
            closeButtonProps={{
              "aria-label": "Custom Close Button aria-label",
              title: "Close",
            }}
            style={{
              borderWidth: "",
              paddingBottom: "",
            }}
          >
            <span className="discard_heading">{heading}</span>
          </MotifModalHeader>
          <MotifModalBody>
            <div className="discard_message">{message}</div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={CancelBtnLabel}
              variant={"secondary"}
              className="delBtn"
              onClickHandler={cancelBtnRejectHandler}
            />
            <Button
              label={ConfirmBtnLabel}
              variant={"primary"}
              className="cancelBtnModal"
              onClickHandler={confirmBtnApproveHandler}
              loading={isLoading}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
